<div class="accordion-item">
    <h3 class="accordion-header" id="headingOne">
        <button class="accordion-button" (click)="showDetails = !showDetails" [ngClass]="{'collapsed':!showDetails}"
            type="button" data-bs-toggle="collapse" data-bs-target="#companyDetails" aria-expanded="true"
            aria-controls="companyDetails">
            <span>Company Details</span>
            <div class="arrow"></div>
        </button>
    </h3>
    <div id="companyDetails" *ngIf="companyDetailsForm" class="accordion-collapse collapse "
        [ngClass]="{'show':showDetails}" aria-labelledby="companyDetails" [formGroup]="companyDetailsForm">
        <div class="accordion-body">
            <div class="row" *ngIf="!thirdPartyTrue">
                <div class="col-12">
                    <div class="form-check d-flex mb-3">
                        <input autocomplete="disabled" class="form-check-input" formControlName="isThirdParty"
                            type="checkbox" id="TPadjudicator{{uniQueId}}" name="deliveryItems"
                            [(ngModel)]="isThirdParty" (change)="isThirdPartyCompany()">
                        <label class="form-check-label link" for="TPadjudicator">Is third party adjudicator</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="upload-wrap upload-insurance">
                        <input type="file" id="UploadItem{{uniQueId}}">
                        <img src="./assets/images/icons/upload-doc.png" alt="">
                        <h4>Upload Logo</h4>
                        <p>Drag and Drop or <a href="#">Choose file</a> to upload<br>
                            <span>JPG, PNG or PDF | 10Mb Max. file size</span>
                        </p>
                    </div>
                </div>
                <div class="col-8 margin-minus">
                    <div class="row">
                        <div class="col-4 mb-3">
                            <label for="companyName" class="form-label">Company Name<span
                                    class="mandatory">*</span></label>

                            <input autocomplete="disabled"
                                [ngClass]="{'is-invalid' : (submitted && companyDetailsForm?.controls?.['companyName']?.errors?.['required'])}"
                                type="text" id="companyName1{{uniQueId}}" formControlName="companyName"
                                class="form-control " placeholder="" appPreventFirstSpace>
                            <span
                                *ngIf="submitted && companyDetailsForm?.controls?.['companyName']?.errors?.['required']"
                                class="invalid-feedback d-block" tabindex="0">This field is required</span>
                        </div>
                        <div class="col-4 mb-3">
                            <label for="companyName" class="form-label">Payer Code<span
                                    class="mandatory">*</span></label>

                            <input autocomplete="disabled"
                                [ngClass]="{'is-invalid' : (submitted && companyDetailsForm?.controls?.['payerCode']?.errors?.['required'])}"
                                type="text" id="payerCode{{uniQueId}}" formControlName="payerCode" class="form-control "
                                placeholder="" appPreventFirstSpace>
                            <span *ngIf="submitted && companyDetailsForm?.controls?.['payerCode']?.errors?.['required']"
                                class="invalid-feedback d-block" tabindex="0">This field is required</span>
                        </div>
                        <div class="col-4 mb-3">
                            <label for="website" class="form-label">Website<span class="mandatory">*</span></label>
                            <input autocomplete="disabled" type="text" formControlName="website"
                                id="website{{uniQueId}}" class="form-control " placeholder="" [ngClass]="{'is-invalid' : (companyDetailsForm?.controls?.['website']?.errors?.['validUrl']) ||
                                (submitted && companyDetailsForm?.controls?.['website']?.errors?.['required'])}"
                                appPreventFirstSpace>
                            <span *ngIf="(companyDetailsForm?.controls?.['website']?.errors?.['validUrl'])"
                                class="invalid-feedback d-block" tabindex="0">Invalid website</span>
                            <span *ngIf="submitted && (companyDetailsForm?.controls?.['webSite']?.errors?.['required'])"
                                class="invalid-feedback d-block" tabindex="0">This field is required</span>
                        </div>
                        <div class="col mb-3">
                            <label for="currencySel" class="form-label">Currency<span class="mandatory">*</span></label>
                            <div
                                [ngClass]="{'is-invalid' : submitted && companyDetailsForm?.controls?.['currency']?.errors}">
                                <app-select-dropdown id="currencyId{{uniQueId}}" [options]="currencyList"
                                    label="currencyDesc" [placeholder]="'Select'" formControlName="currency">
                                </app-select-dropdown>
                            </div>
                            <span
                                *ngIf="submitted && (companyDetailsForm?.controls?.['currency']?.errors?.['required'])"
                                class="invalid-feedback d-block" tabindex="0">This field is required</span>
                        </div>
                        <div class="col mb-3">
                            <label for="AsCountry" class="form-label">Associated Country<span
                                    class="mandatory">*</span></label>
                            <div
                                [ngClass]="{'is-invalid' : submitted && companyDetailsForm?.controls?.['associatedCountry']?.errors}">
                                <app-select-dropdown uid="countryId" [search]=true [options]="countryList"
                                    label="countryName" [placeholder]="'Select'" formControlName="associatedCountry">
                                </app-select-dropdown>
                            </div>
                            <span
                                *ngIf="submitted && companyDetailsForm?.controls?.['associatedCountry']?.errors?.['required']"
                                class="invalid-feedback d-block" tabindex="0">This field is required</span>

                        </div>
                        <div class="col-5 mb-3">
                            <label for="insValidity" class="form-label">Validity<span class="mandatory">*</span></label>
                            <div>
                                <app-datepicker_v2 formControlName="validity" [field]="validity_date_v2"
                                    [disabled]="isEdit" [isInValid]="(submitted && companyDetailsForm?.controls?.['validity']?.errors?.['required'] ||
                            (companyDetailsForm?.controls?.['validity']?.errors?.['validityPattern']) || (companyDetailsForm?.controls?.['validity']?.errors?.['checkEndDate'])
                            || (companyDetailsForm?.controls?.['validity']?.errors?.['checkStartDate']))">
                                </app-datepicker_v2>
                            </div>
                            <span *ngIf="submitted && companyDetailsForm?.controls?.['validity']?.errors?.['required']"
                                class="invalid-feedback d-block" tabindex="0">This field is required</span>
                            <span *ngIf="companyDetailsForm?.controls?.['validity']?.errors?.['validityPattern']"
                                class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
                            <span *ngIf="companyDetailsForm?.controls?.['validity']?.errors?.['checkEndDate']"
                                class="invalid-feedback d-block" tabindex="0">{{EndDateError}}</span>
                            <span *ngIf="companyDetailsForm?.controls?.['validity']?.errors?.['checkStartDate']"
                                class="invalid-feedback d-block" tabindex="0">{{startDateError}}</span>

                        </div>
                        <div class="col-12 mb-4">
                            <label for="INSDescription" class="form-label">Description</label>
                            <textarea autocomplete="disabled"
                                [ngClass]="{'is-invalid':submitted && (companyDetailsForm?.controls?.['description']?.errors?.['maxlength'])}"
                                id="groupDescription{{uniQueId}}" formControlName="description"
                                class="form-control  min-height-text-area" placeholder=""></textarea>
                            <span
                                *ngIf="submitted && (companyDetailsForm?.controls?.['description']?.errors?.['maxlength'])"
                                class="invalid-feedback d-block" tabindex="0">Max Char. Limit 500</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>